var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{ref:"form",attrs:{"method":"post"}},[_c('input',{attrs:{"type":"hidden","name":_vm.tokenName},domProps:{"value":_vm.tokenValue}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"action"},domProps:{"value":_vm.action}}),_vm._v(" "),(_vm.param)?_c('input',{attrs:{"type":"hidden","name":_vm.param},domProps:{"value":_vm.value}}):_vm._e(),_vm._v(" "),_vm._l((_vm.ids),function(id,index){return _c('input',{key:index,attrs:{"type":"hidden","name":"ids[]"},domProps:{"value":id}})}),_vm._v(" "),_c(_vm.isMenuButton ? 'div' : 'button',_vm._g({ref:"button",tag:"component",staticClass:"btn",class:_vm.menuBtnClasses,attrs:{"data-icon":_vm.icon,"disabled":_vm.buttonDisabled,"type":_vm.enabled && !_vm.isMenuButton && !_vm.ajax ? 'submit' : null}},
      _vm.enabled && !_vm.isMenuButton && _vm.ajax
        ? {click: _vm.handleClick(_vm.param, _vm.value, _vm.action, _vm.ajax, _vm.handleClick)}
        : {}
    ),[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),(_vm.isMenuButton)?_c('div',{staticClass:"menu"},[_vm._l((_vm.actionsList),function(actList,ind){return [(
          _vm.actionsList.length > 1 && ind === _vm.actionsList.length - 1 && ind != 0
        )?_c('hr',{key:ind}):_vm._e(),_vm._v(" "),_c('ul',{key:ind,staticClass:"padded"},_vm._l((actList),function(act,index){return _c('li',{key:index},[_c('a',{class:{
              ...(act.class ? act.class : {}),
              ...{
                error: act.error,
                disabled:
                  typeof act.allowMultiple !== 'undefined' &&
                  !act.allowMultiple &&
                  _vm.hasMultipleSelected,
              },
            },attrs:{"href":"#","data-param":act.param,"data-value":act.value,"data-ajax":act.ajax},on:{"click":function($event){$event.preventDefault();!(
                typeof act.allowMultiple !== 'undefined' &&
                !act.allowMultiple &&
                _vm.hasMultipleSelected
              )
                ? _vm.handleClick(
                    act.param,
                    act.value,
                    act.action,
                    act.ajax,
                    act.handleClick
                  )
                : null}}},[(act.status)?_c('span',{class:'status ' + act.status}):_vm._e(),_vm._v(_vm._s(act.label)+"\n          ")])])}),0),_vm._v(" "),(
          _vm.actionsList.length > 1 && ind != _vm.actionsList.length - 1 && ind != 0
        )?_c('hr',{key:ind}):_vm._e()]})],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }